<div class="flex items-center gap-2">
  <!-- Sorting list -->
  <button
    [matMenuTriggerFor]="menu"
    class="mat-dense bg-accent-700 text-smaller pe-4 text-white"
    mat-flat-button
  >
    <span class="text-secondary ms-1 me-1">{{ 'Sort by' | transloco }}:</span>
    {{ selectedSortOption | transloco }}
    <mat-icon class="icon-size-5 ms-1" svgIcon="mat_solid:arrow_drop_down"></mat-icon>
    <mat-menu #menu="matMenu">
      <button
        (click)="onSortOptionSelected(option)"
        *ngFor="let option of sortingOptions"
        class="flex"
        mat-menu-item
      >
        {{ option.value | transloco }}
      </button>
    </mat-menu>
  </button>

  <!-- Toggle sorting order button -->
  <button (click)="onToggleSorting()" class="floating-icon flex items-center justify-center">
    <mat-icon
      [svgIcon]="
        isAscendingSorting ? 'heroicons_solid:sort-descending' : 'heroicons_solid:sort-ascending'
      "
      [matTooltip]="
        isAscendingSorting ? ('Descending order' | transloco) : ('Ascending order' | transloco)
      "
      matTooltipPosition="above"
      class="icon-size-5"
    ></mat-icon>
  </button>
</div>
